import normalizeText from '../plugins/normalize-text';

export const byWordsNormalizedSelectFilter = (item, queryText, itemText) => {
  const normalizedQueryText = normalizeText(queryText);
  const normalizedItemText = normalizeText(itemText);
  const regexText = normalizedQueryText
    .split(' ')
    .map(word => word.replace(/^["']|["']$/g, ''))
    .join('|');

  const regex = new RegExp(regexText);
  return regex.test(normalizedItemText);
};

export const strictNormalizedSelectFilter = (item, queryText, itemText) => {
  const query = queryText.replace(/^"|"$/g, '');
  return normalizeText(itemText).indexOf(normalizeText(query)) > -1;
};

export default strictNormalizedSelectFilter;
